import { Button } from "../ui/button";
import { DialogTrigger } from "../ui/dialog";
import { RefreshCw, Plus } from "lucide-react";

type UserHeaderProps = {
  isLoading: boolean;
  onRefresh: () => void;
  onOpenCreateDialog: () => void;
};

export const UserHeader = ({
  isLoading,
  onRefresh,
  onOpenCreateDialog,
}: UserHeaderProps) => {
  return (
    <div className="rounded-2xl border border-border/60 bg-white/80 p-4 shadow-sm backdrop-blur">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-muted-foreground">
            Admin workspace
          </p>
          <h1 className="text-2xl font-semibold text-foreground">
            Users & Access
          </h1>
          <p className="max-w-xl text-sm text-muted-foreground">
            Audit account access, reset credentials, and keep roles aligned with
            your org chart.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="icon"
            onClick={onRefresh}
            disabled={isLoading}
            className="h-10 w-10 rounded-full border-border/70 bg-white/70"
          >
            <RefreshCw
              className={`h-4 w-4 ${isLoading ? "animate-spin" : ""}`}
            />
          </Button>
          <DialogTrigger asChild>
            <Button
              onClick={onOpenCreateDialog}
              className="gap-2 rounded-full bg-lime-600 text-white shadow hover:bg-lime-600/90"
            >
              <Plus className="h-4 w-4" />
              Add user
            </Button>
          </DialogTrigger>
        </div>
      </div>
    </div>
  );
};
